const initialState = {
  userRole: "volunteer",
  authLoading: true,
  user: null,
  roleFromClaims: null,
  values: {
    isSignedIn: false,
    email: null,
    name: null,
  }
}

export const login = (state = { ...initialState }, action) => {
  switch (action.type) {
    case "LOGIN_WITH_EMAIL": {
      return { ...state, values: action.payload, user: action.user }
    }
    case "AUTH_LOADING": {
      return { ...state, authLoading: action.authLoading }
    }
    case "LOGOUT_FB": {
      return { ...state, values: { ...initialState.values }, user: null }
    }
    case "LOGIN_WITH_FB": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_TWITTER": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_GOOGLE": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_GITHUB": {
      return { ...state, values: action.payload }
    }
    case "LOGIN_WITH_JWT": {
      return { ...state, values: action.payload }
    }
    case "LOGOUT_WITH_JWT": {
      return { ...state, values: action.payload }
    }
    case "LOGOUT_WITH_FIREBASE": {
      return { ...state, values: action.payload }
    }
    case "CHANGE_ROLE": {
      return { ...state, userRole: action.userRole }
    }
    case "CHANGE_ROLE_CLAIMS": {
      return { ...state, roleFromClaims: action.roleFromClaims }
    }
    default: {
      return state
    }
  }
}
